import React, { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

interface ToastProps {
  type?: 'success' | 'error'
  onClose: () => void
  className?: string
  children?: React.ReactNode
}

export default function Toast({
  type = 'success',
  onClose,
  className = '',
  children,
}: ToastProps) {
  const [isVisible, setIsVisible] = useState(true)

  // 외부 타이머 제거 → 내부에서 setTimeout 사용
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false) // 사라지는 애니메이션 시작
    }, 1500)

    return () => clearTimeout(timer)
  }, [])

  return (
    <AnimatePresence mode="wait">
      {isVisible && (
        <motion.div
          key="toast"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{
            scale: {
              type: 'spring',
              duration: 0.5,
              bounce: 0.4,
            },
            opacity: { duration: 0.3 },
          }}
          onAnimationComplete={(definition) => {
            if (definition === 'exit') {
              onClose()
            }
          }}
          className={`
            rounded-md text-base font-semibold shadow-lg transition-none
            ${type === 'success' ? 'bg-[#2CC18F] text-white' : 'bg-red-300 text-white'}
            ${className}
          `}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  )
}